import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CampaignMap from './components/CampaignMap';
import CampaignLanding from './components/CampaignLanding';
import './App.css';

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Default route shows campaign selection landing page */}
        <Route path="/" element={<CampaignLanding />} />
        
        {/* Campaign route - dynamic campaign loading */}
        <Route path="/:campaignName" element={<CampaignMap />} />
        
        {/* Catch-all route for invalid campaigns */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;
